<div class="spinner align-middle {{classes}}">
  <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
  <span class="text pl-4">{{text}}</span> 
</div>